import { render, staticRenderFns } from "./JoinPreview.vue?vue&type=template&id=60d4164d&scoped=true"
import script from "./JoinPreview.vue?vue&type=script&lang=ts"
export * from "./JoinPreview.vue?vue&type=script&lang=ts"
import style0 from "./JoinPreview.vue?vue&type=style&index=0&id=60d4164d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4164d",
  null
  
)

export default component.exports